export default __webpack_public_path__ + "static/media/Believer's Cloth of the Eldritch.9e5a8a6a.jpg";